// @ts-check

import React from "react"
import { ContextMenu as PrimeContextMenu } from "primereact/contextmenu"

const ContextMenu = React.forwardRef(
  /**
   * @param {any} props
   * @param {React.ForwardedRef<PrimeContextMenu>} ref
   */
  (props, ref) => {
    return <PrimeContextMenu ref={ref} {...props} />
  }
)

export default ContextMenu
